import './mobileHome.css';

const ResponseStatus = ({ message, responseImg }) => {
    return (
        <div className='flex flex-column gap-4'>
            <div className='statusImg'>
                <img src={responseImg} />
            </div>
            <div className='text-message'>
                <div className='notification'>{message}</div>
            </div>
        </div>
    );
};

export default ResponseStatus;
